import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import { FaExclamationTriangle } from "react-icons/fa";
import "./ChecklistLayout.css";

function ChecklistLayout(
    { leftContent = { title: "", content: "" },
        middleContent = { title: "", content: "", filters: null },
        rightContent = { title: "", content: "" },
        topContent = null
    }) {
    const [dadosUsuario, setDadosUsuario] = useState("");
    const [rightCollapsed, setRightCollapsed] = useState(false);
    const { pathname } = useLocation();
    const { operador } = useAuthContext();

    useEffect(() => {
        // Carrega dados do usuário
        //const usu = localStorage.getItem("usuarioLogado");        
        if (operador) {
            //const json = JSON.parse(usu);
            setDadosUsuario(operador);
        }
    }, [pathname, operador]);

    const toContentObject = (value) => {
        if (value && typeof value === "object" && ("title" in value || "content" in value)) {
            return value;
        }
        return { title: "", content: value, actions: null, filters: null, progress: null };
    };

    const normalizedLeft = toContentObject(leftContent);
    const normalizedMiddle = toContentObject(middleContent);
    const normalizedRight = toContentObject(rightContent);

    const middleProgressRaw = normalizedMiddle?.progress;
    const middleProgressValue = Number.isFinite(middleProgressRaw)
        ? middleProgressRaw
        : Number.isFinite(middleProgressRaw?.value)
            ? middleProgressRaw.value
            : null;
    const middleProgress =
        middleProgressValue === null ? null : Math.min(100, Math.max(0, middleProgressValue));

    const rightHasAlert = Boolean(normalizedRight?.hasAlert);

    return (
        <>
            {topContent ? (
                topContent
            ) : (
                <>
                    {/* Navbar fixo no topo */}
                    <div className="navbar">
                        {dadosUsuario ? `${dadosUsuario.IDOperador} - ${dadosUsuario.nome}` : "Carregando..."}
                    </div>

                    {/* Cabeçalho */}
                    <div className="header">
                        <p>CATEGORIA - Licitação ABC</p>
                    </div>
                </>
            )}

            {/* Layout do conteúdo */}
            <div className="content">
                <div className="grid-container-checklist">
                    <div className="grid-shape grid-shape--main">
                        <div className="grid-title">
                            <div className="grid-title-inner">{normalizedLeft.title}</div>
                            {normalizedLeft.actions ? (
                                <div className="grid-title-actions">{normalizedLeft.actions}</div>
                            ) : null}
                        </div>
                        <div className="grid-item">{normalizedLeft.content}</div>
                    </div>

                    <div className="grid-shape grid-shape--main">
                        <div className="grid-title">
                            <div className="grid-title-inner">{normalizedMiddle.title}</div>
                        </div>
                        {middleProgress !== null && (
                            <div
                                className="grid-progress-divider"
                                role="progressbar"
                                aria-valuemin={0}
                                aria-valuemax={100}
                                aria-valuenow={middleProgress}
                            >
                                <div className="grid-progress-track">
                                    <div
                                        className="grid-progress-fill"
                                        style={{ width: `${middleProgress}%` }}
                                    />
                                </div>
                            </div>
                        )}
                        {normalizedMiddle.filters ? (
                            <div className="grid-filters">{normalizedMiddle.filters}</div>
                        ) : null}
                        <div className="grid-item">{normalizedMiddle.content}</div>
                    </div>

                    <div className={`grid-shape grid-shape--right ${rightCollapsed ? "is-collapsed" : ""}`}>
                        <div className="grid-title grid-title--collapsible">
                            <div className="grid-title-inner">{normalizedRight.title}</div>
                            <div className="grid-title-actions">
                                {rightCollapsed && rightHasAlert && (
                                    <FaExclamationTriangle className="grid-title-alert" />
                                )}
                                <button
                                    type="button"
                                    className="grid-title-toggle"
                                    aria-expanded={!rightCollapsed}
                                    onClick={() => setRightCollapsed((prev) => !prev)}
                                    title={rightCollapsed ? "Expandir" : "Minimizar"}
                                >
                                    {rightCollapsed ? "<" : ">"}
                                </button>
                            </div>
                        </div>
                        <div className="grid-item">{normalizedRight.content}</div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ChecklistLayout;
